import { MapDispatchToPropsFunction } from 'react-redux'
import RewardDetails, { RewardDetailsDispatchProps, RewardDetailsStateProps } from 'components/features/pfm/RewardDetails/RewardDetails'
import withMobile from 'hocs/withMobile/withMobile'
import { connectLoadable } from 'helpers/loadableHelpers'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { createSelector } from 'reselect'
import { Guards } from 'interfaces/guards'
import { rewardsGuard } from 'guards/bountyGuards'
import {
  isRewardModalOpenedSelector,
  rewardDismissingIdSelector,
  rewardItemsAppSelector,
  rewardItemsDataSelector,
  rewardModalTypeSelector,
} from 'selectors/bountySelectors'
import { getRewardsActionCreator, toggleDismissRewardActionCreator, toggleRewardDetailsModalActionCreator } from 'actions/bountyActions'
import { StoreDispatch } from 'interfaces/component'
import { getPageSizeProps, getPaginatorProps } from 'helpers/tableHelpers'
import { BountyAppState, Reward } from 'interfaces/bounty'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { FLOATING_PANE_CRYPTO_REWARDS_TYPE, FLOATING_PANE_ORDER_DETAILS_MODE } from 'components/features/rewards/rewardsPane/constants/paneState'

const createMapStateToProps = () =>
  createSelector(
    rewardItemsDataSelector,
    rewardItemsAppSelector,
    isRewardModalOpenedSelector,
    rewardDismissingIdSelector,
    rewardModalTypeSelector,
    (rewardItemsData, rewardItemsApp, isModalOpened, dismissingId, modalType): RewardDetailsStateProps => {
      if (!rewardItemsData) {
        throw createForgottenGuardError('RewardDetailsContainer', 'rewardsGuard')
      }

      const {
        isLoading,
        filter,
      } = rewardItemsApp

      const { results } = rewardItemsData

      return {
        isLoading,
        dismissingId,
        isModalOpened,
        modalType,
        rowsCollection: results,
        activeFilter: filter,
        paginator: getPaginatorProps(rewardItemsApp, rewardItemsData),
        pageSize: getPageSizeProps(rewardItemsApp),
      }
    }
  )

const mapDispatchToProps: MapDispatchToPropsFunction<RewardDetailsDispatchProps> = (dispatch: StoreDispatch) => ({
  onPageClick: (page: number) => dispatch(getRewardsActionCreator.request({ page })),
  onPageSizeClick: (pageSize: number) => dispatch(getRewardsActionCreator.request({ pageSize, page: 1 })),
  onDismissClick: (reward: Reward) => dispatch(toggleDismissRewardActionCreator.request(reward)),
  onProgressClick: (modalType: BountyAppState['reward']['modalType']) => dispatch(toggleRewardDetailsModalActionCreator(modalType)),
  onCloseModalClick: () => dispatch(toggleRewardDetailsModalActionCreator(false)),
  onOpenCryptoDetails: (cryptoOrderUUID: string): void => {
    dispatch(modifyFloatingPaneActionCreator(
      FLOATING_PANE_CRYPTO_REWARDS_TYPE, {
        mode: FLOATING_PANE_ORDER_DETAILS_MODE,
        fields: {
          openOrderId: cryptoOrderUUID,
        },
      }
    ))
  },
})

const guards: Guards = [
  rewardsGuard,
]

const RewardDetailsContainerInner = withMobile(RewardDetails)

const RewardDetailsContainer = connectLoadable<
  RewardDetailsStateProps,
  RewardDetailsDispatchProps
>(guards)(createMapStateToProps, mapDispatchToProps)(RewardDetailsContainerInner)

export default RewardDetailsContainer
